import { useEffect, useState } from 'react';
import { useFeatureFlag } from '../services/featureFlags';
import { loadMigrationCheckpoint } from '../idb/migration-utils';
import { dbV5 } from '../idb/chunk-db-v5';
import logger from '../utils/logger';

export function useMigration() {
  const isV5Enabled = useFeatureFlag('indexeddb-v5');
  const [isMigrating, setIsMigrating] = useState(false);
  const [migrationComplete, setMigrationComplete] = useState(false);
  const [migrationError, setMigrationError] = useState<string | null>(null);

  useEffect(() => {
    if (!isV5Enabled) {
      return;
    }

    const checkpoint = loadMigrationCheckpoint();
    
    if (checkpoint) {
      if (checkpoint.stage === 'complete') {
        setMigrationComplete(true);
        setIsMigrating(false);
      } else {
        setIsMigrating(true);
      }
      return;
    }

    const initMigration = async () => {
      try {
        setIsMigrating(true);
        logger.info('🔄 Initializing IndexedDB v5...');
        
        await dbV5.open();
        
        logger.info('✅ IndexedDB v5 initialized successfully');
        setMigrationComplete(true);
        setIsMigrating(false);
      } catch (error) {
        logger.error('❌ Migration failed:', error);
        setMigrationError(error instanceof Error ? error.message : String(error));
        setIsMigrating(false);
      }
    };

    initMigration();
  }, [isV5Enabled]);

  return {
    isV5Enabled,
    isMigrating,
    migrationComplete,
    migrationError,
  };
}
